import React, { useState, useEffect, useContext } from 'react'
import verifiedbyvisamastercard from '../../assets/verifiedbyvisamastercard.svg'
import verifiedbyvisa from '../../assets/verifiedbyvisa.svg'

import KRGlue from '@lyracom/embedded-form-glue'
import { AddTransaction, ValidateTransfer } from 'requests/transfer'
import { Spinner } from 'utils/loading'
import ModalPayment from './modalPayment'
import { useNavigate } from 'react-router-dom'
import UserContext from 'contexts/UserContext'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import { ProfileRequest } from 'requests/user'
import LoadingForm from 'containers/loadingForm'
const ListePartnerId:Record <string ,string>={
  'MAD': '66757f4c4e5d0ed8aaffede8',
  'PKR': '69fdebb1497ad978337ebaa1',
  'BDT' : '66a006c4eef2721b09cd4f1b'

}

interface props {
  departureCurrencyId: string
  destinationCurrencyId: string
  amountD: number
  currencyToTND: number
  modePay?: string
  com: number
  totalSend: number
  benificiareId: string
  motif: string
  colectPointId?: string
  senderId: string | undefined
  token: string | undefined
  taux: number
  setOpenAlert?: () => void
  idBeneficiary?: any
  banqueName?: any
  iban?: any
  choisirCarte?: any
  reseaux?: any
  paymentMode: any
  bnfidentifiant?: any
  bankcode?: any
  swiftBic?: any
  promoCode: any
  valuePays: any
  networkChecked?: string
  functionTracks: any
  fxRateFirstTransfer?: any
}
const Paiement: React.FC<props> = ({
  departureCurrencyId,
  destinationCurrencyId,
  amountD,
  currencyToTND,
  modePay,
  fxRateFirstTransfer,
  com,
  totalSend,
  benificiareId,
  motif,
  colectPointId,
  senderId,
  token,
  taux,
  setOpenAlert,
  idBeneficiary,
  banqueName,
  iban,
  choisirCarte,
  reseaux,
  paymentMode,
  bnfidentifiant,
  bankcode,
  swiftBic,
  promoCode,
  valuePays,
  networkChecked,
  functionTracks,
}) => {
  const navigate = useNavigate()

  // const { user } = useContext(UserContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)

  // const statusComplete = user?.user?.status === 'confirmed' && user?.user?.isDocumentSent
  // const statusPending = user?.user?.status === 'pending' && user?.user?.isDocumentSent
  // const statusNotFound = user?.user?.status === 'pending' && !user?.user?.isDocumentSent

  const [message, setMessage] = useState('')
  const [messageError, setMessageError] = useState(false)

  const [publicKey, setKey] = useState('')
  const [formToken, settokenT] = useState('')
  const [loading, setLoading] = useState(false)
  const [linkPaiment, setLinkPaiment] = useState('')
  const [openModal, setOpenModal] = useState(false)

  const [responseSuccess, setResponseSuccess] = useState(false)
  const [responseFailed, setResponseFailed] = useState(false)

  const [isFailed, setIsFailed] = useState(false)

  const [showErrorMsg, setShowErrorMsg] = useState('')
  const[paymentUrl, setPaymentUrl] = useState('')
  const [isValid, setIsValid]= useState<boolean>()
  const [numListeHistory,setNumListeHistory]= useState<number>()
  const closeModalPayment = () => {
    setOpenModal(false)
  } 

  const openModalPayment = () => {
    setOpenModal(true)
  }
  // const [seconds, setSeconds] = useState(20)

  
// useEffect(() => {
//   const interval = setInterval(() => {
//     setSeconds((prev) => {
//       if (prev > 0) {
//         return prev - 1
//       } else {
//         clearInterval(interval) 
//         return 0
//       }
//     })
//   }, 1000) 

//   return () => clearInterval(interval) 
// }, [])

 useEffect(() => {
    const credentials: any = {
      amountToRecieve: currencyToTND,
      amountToSend: amountD,
      commissionValue: com,
      departureCurrencyId: departureCurrencyId,
      destinationCurrencyId: destinationCurrencyId,
      distributionInfo: {
        partnerId: choisirCarte === '0' ? valuePays.value === 'TND' ? colectPointId : ListePartnerId[valuePays.value] : null,
        channel: `${choisirCarte === '0' ? 'cash_pickup' : choisirCarte === '1' ? 'bank_account' : 'digital_wallet'}`,
      },
      fxRateBank: null,
      //fxRateCustomer: fxRateFirstTransfer !== undefined ? fxRateFirstTransfer : com,
      fxRateCustomer: taux,
      network:
        networkChecked 
          ? networkChecked
          : reseaux?.toLowerCase?.() === 'viamobile'
            ? 'Viamobile'
            : reseaux?.toLowerCase?.() === 'wafacash'
              ? 'Wafacash'
              : reseaux
                ? reseaux
                : TransferData?.operateurWallet ,
                // ? 'Orange Money Senegal' : null,
      paimentMode: paymentMode,
      paymentInitiantion: false,
      reason: motif,
      recieverId: TransferData?.idBeneficiary,
      senderId: senderId,
      totalAmount: totalSend,
      bankName: choisirCarte === '1' ? banqueName : null,
      Iban: choisirCarte === '1' ? TransferData?.codeIso==='TUR'? `TR${iban}` :iban : null,
      beneficiaryIdentifiant: choisirCarte === '1' ? bnfidentifiant : null,
      bankCode: choisirCarte === '1' ? bankcode : null,
      SWIFTBIC: choisirCarte === '1' ? swiftBic : null,
      promoCode: promoCode ? promoCode : null,
      destinationCountryCode: TransferData?.codeIso ,
      platform: 'web'
    }

   async function setupPaymentForm() {
      const endpoint = 'https://api.payzen.eu'
      // let publicKey: any = null
      // let formToken: any = null
      let transferID: any = null
      try {
        

        await AddTransaction(token, credentials)
          .then(async (response: any) => {
            //  setPaymentUrl (response?.paymentUrl)
            //setPaymentUrl (response?.paymentDetails.url)

            // checkout

            // publicKey = response?.paymentDetails?.public_key
            // formToken = response?.paymentDetails?.payzen_sdk_token
            setIsValid(response.success)

            transferID = response?.transferId
            localStorage.setItem(
              'pi',
              JSON.stringify({ piID: response?.transferId, paymentMode: paymentMode, token: token }),
            )
           
            functionTracks('4')
            if (response.success && response?.paymentUrl !== '') {

              if(paymentMode == 'cb' ){
              setLinkPaiment(response?.paymentUrl)}
              else(setLinkPaiment(response?.paymentUrl.url))
              setTransferData(null)
              setLoading(true)
            } else if (response?.success === false && response?.code === 3000) {
              setShowErrorMsg(response?.msg)
              setTransferData(null)
            } else {
              setIsFailed(true)
              setTransferData(null)
            }
          })
          .catch((error: any) => {
            setMessageError(true)
            console.log(error)
          })
        setLoading(true)
        setTransferData(null)
        

        // const { KR } = await KRGlue.loadLibrary(endpoint, publicKey) /* Load the remote library */
        // await KR.setFormConfig({
        //   /* set the minimal configuration */
        //   formToken: formToken,
        //   'kr-language': 'fr' /* to update initialization parameter */,
        // })
      

        // const { result } = await KR.attachForm('#myPaymentForm') /* Attach a payment form  to myPaymentForm div*/
        // await KR.showForm(result.formId) /* show the payment form */
        // const body = {
        //   transferId: transferID,
        //   promoCode: promoCode ? promoCode : null,
          
        // }

        // await KR.onSubmit(async (paymentData) => {
        //   const response = await ValidateTransfer(token, body)
        //     .then(async (response: any) => {
        //       console.log('rrr', response)
        //       if (response?.data?.success) {
        //         setResponseSuccess(true)
        //         const transfertType = choisirCarte === '0' ? 1 : choisirCarte === '1' ? 2 : 5

        //         navigate('/success', { state: { responseSuccess, transfert: 1, path: transfertType} })
               
        //       } else {
        //         setResponseFailed(true)
        //         navigate('/error', { state: { responseFailed, transfert: 1 } })
        //       }
        //     })
        //     .catch((error: any) => {
        //       console.log('message error', error)
        //     })
        //   return false //Return false to prevent the redirection
        // })
      } catch (error) {
        setMessage(error + ' (see console for more details beem)')
      }
    }
    setupPaymentForm()
  }, [])
    useEffect(()=>{
      if(linkPaiment){
        window.location.href = linkPaiment 
      }
    },[linkPaiment])


  return (
    <div className="form ">
      {loading ?
       (
        
        <>
        { !isValid ? 
        <div className='text-center mt-10 font-semibold text-[22px]'> Désolé, une erreur est survenue. <br/> Veuillez essayer à nouveau.</div> 
        :
       
       <div className="h-full  relative mx-auto">
     
          {/* <LoadingForm />
          <div></div>
          <div className="bg-[#FFFFFF] absolute rounded-[16px] w-[450px] sm:w-[300px] h-[100px] p-6  shadow-selct
                          top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                <a href={linkPaiment}  className=' w-full flex items-center justify-center h-[56px] rounded-[16px] font-bold text-center bg-[#5754E5] text-[#FFFFFF]'>
                  Accéder au formulaire du paiement
                </a>
            </div> */}
         
          </div>
          }
        </>
      ) : messageError ? (
        <div className="text-red-500 text-center text-[18px] py-5 mx-5 max-w-max">
          Vous avez atteint le nombre maximal de transferts autorisés par jour.
        </div>
      ) : showErrorMsg ? (
        <div className="text-red-500 text-center text-[18px] py-5 mx-5 max-w-max">{showErrorMsg}</div>
      ) : isFailed ? (
        <div className="text-red-500 text-center text-[18px] py-5 mx-5 max-w-max">
          Erreur du serveur, veuillez réessayer plus tard.
        </div>
      ) : (
        <div className="h-full flex flex-col items-center text-[18px]  relative mx-auto ">
       
      
          <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />
          
        </div>
      )}
    </div>
  )
}

export default Paiement
